import { Component, OnInit } from '@angular/core';
import { FibberglassRequestService } from '../../services/fibberglass-request.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { UserResponseDto } from '../../models/adminResponseDto';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';

@Component({
  selector: 'app-fibberglass-offline-payment',
  templateUrl: './fibberglass-offline-payment.component.html',
  styleUrls: ['./fibberglass-offline-payment.component.css']
})
export class FibberglassOfflinePaymentComponent implements OnInit {

  RequestId: string;
  ConfirmPaymentForm: FormGroup;
  submitted = false;
  loading = false;
  responseObj: ResponseObject;
  showRequest = true;

  constructor(private fibberglassService: FibberglassRequestService, private route: ActivatedRoute, private router: Router, private global: GlobalServices, private formBuilder: FormBuilder, private authSrevice: AuthenticationService) {
    if (history.state.data && history.state.data.requestId)
      this.RequestId = history.state.data.requestId;
    //this.RequestId = this.route.snapshot.params.Id;
    this.createForm();
  }

  ngOnInit() {

  }

  get Validate() {
    return this.ConfirmPaymentForm.controls;
  }

  createForm() {
    this.ConfirmPaymentForm = this.formBuilder.group({
      PaymentConfirmation: ['', Validators.requiredTrue]
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.ConfirmPaymentForm.invalid) {
      return;
    }
    //Enable Loader
    this.global.isLoaderEnabled = true;
    this.loading = true;
    var ConfirmResponse = new UserResponseDto();
    ConfirmResponse.response = this.Validate.PaymentConfirmation.value ? 1 : 0;
    ConfirmResponse.requestId = this.RequestId;
    ConfirmResponse.userName = this.authSrevice.currentUserValue.UserName;
    this.fibberglassService.ConfirmFibberglassPayment(ConfirmResponse).subscribe(
      (data: ResponseObject) => {
        this.responseObj = data;
        if (this.responseObj.Success) {
          let message: string;
          this.ConfirmPaymentForm.reset();
          this.showRequest = false;
          this.loading = false;
          //Disable Loader
          this.global.isLoaderEnabled = false;
          // console.log("Success");
        }
        else {
          this.loading = false;
          //Disable Loader
          this.global.isLoaderEnabled = false;
          // console.log("Fail");
        }
      });
  }
}
